export enum MediaStatus {
  None = -1,
  Encoding = 1,
  Available = 2,
  BadFormat = 3,
  Error = 4,
}
